import { render, staticRenderFns } from "./CentroHemodialiseComponente.vue?vue&type=template&id=350eae1d&scoped=true"
import script from "./CentroHemodialiseComponente.vue?vue&type=script&lang=js"
export * from "./CentroHemodialiseComponente.vue?vue&type=script&lang=js"
import style0 from "./CentroHemodialiseComponente.vue?vue&type=style&index=0&id=350eae1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350eae1d",
  null
  
)

export default component.exports